<template>
  <v-card elevation="0" class="pa-2">
    <v-dialog v-model="dialogDetailCourse" max-width="900px">
      <DetailCourse
          v-if="currentCourse && currentCourse.id"
          :courseId="currentCourse.id"
          ref="detailCourse"
          @close="dialogDetailCourse = false"
      >
      </DetailCourse>
    </v-dialog>

    <v-row cols="12" class="ma-0">
      <v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
        <strong>Nome: </strong>
        <span>{{ combo.name }}</span>
      </v-col>

      <v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
        <strong>Descrição: </strong>
        <span>{{ combo.description }}</span>
      </v-col>
    </v-row>

    <v-row cols="12" class="ma-0 mt-2">
      <v-divider></v-divider>
    </v-row>

    <v-row cols="12" class="ma-0">
      <v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
        <strong>Data de início das inscrições: </strong>
        <span>{{ formatDate(combo.startDate) }}</span>
      </v-col>

      <v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
        <strong>Data de término das inscrições: </strong>
        <span>{{ formatDate(combo.endDate) }}</span>
      </v-col>

      <v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
        <strong>Preço: </strong>
        <span>{{ formatCurrency(combo.price) }}</span>
      </v-col>
    </v-row>

    <v-row cols="12" class="ma-0 px-1 mt-2">
      <v-card
          elevation="1"
          class=""
          width="100%"
      >
        <v-toolbar
            color="#bc0000"
            dark
            elevation="0"
            height="40"
        >
          <p class="title-toolbar">Cursos adicionados ao combo</p>

          <v-spacer></v-spacer>
        </v-toolbar>

        <v-row cols="12" class="ma-0 pa-1" v-if="combo && combo.combosTOCourses && combo.combosTOCourses.length > 0">
          <v-col
              class="ma-0 pa-1"
              v-for="comboTOCourse in combo.combosTOCourses"
              :key="comboTOCourse.id"
              cols="12" xs="12" sm="12" md="6" lg="4" xl="4"
          >
            <v-card
                elevation="1"
                class="px-3 py-2 ma-0 pa-0 selected-course"

            >
              <div class=" ">
                <div>
                  <p class="mb-2">
                    <strong class="mr-1">Nome:</strong>
                    <span>{{ comboTOCourse.course.name }}</span>
                  </p>

                  <p class="mb-2">
                    <strong class="mr-1">Data de início:</strong>
                    <span>{{ formatDate(comboTOCourse.course.startDate) }}</span>
                  </p>
                  <p class="mb-2">
                    <strong class="mr-1">Data de término:</strong>
                    <span>{{ formatDate(comboTOCourse.course.endDate) }}</span>
                  </p>

                  <p class="mb-2">
                    <strong class="mr-1">Quantidade de vagas:</strong>
                    <span>{{ comboTOCourse.course.numberOfVacancies }}</span>
                  </p>

                  <p class="mb-2">
                    <strong class="mr-1">Preço:</strong>
                    <span>{{ formatCurrency(comboTOCourse.price) }}</span>
                  </p>
                </div>

                <div>
                  <v-btn
                      outlined
                      tile
                      style="border-radius: 4px"
                      class="quinary-button"
                      color="quaternary"
                      width="120"
                      @click="showDialogDetailCourse(comboTOCourse.course)"
                  >
                    <v-icon size="25" dark>mdi-eye-outline</v-icon>
                    <span>Detalhar</span>
                  </v-btn>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <v-row cols="12" class="ma-0" v-else>
          <h4 class="pa-3">Não há cursos adicionados ao combo</h4>
        </v-row>
      </v-card>
    </v-row>


    <v-row class="ma-0">
      <v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
        <v-btn
            elevation="0"
            class="secondary-button"
            width="100%"
            @click="close()"
        >
          <span>Fechar</span>
        </v-btn>
      </v-col>
      <v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
        <v-btn
            elevation="0"
            class="primary-button"
            width="100%"
            @click="goToRoute()"
        >
          <span>Editar</span>
        </v-btn>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import ApiService from "../../../../services/ApiService";
import Utils from "../../../../Utils/FormatDate";
import Vue from "vue";
import UtilsFormatCurrency from "@/Utils/FormatCurrency";
import DetailCourse from "@/views/pages/Courses/components/DetailCourse.vue";

export default {
  name: "DetailCombo",
  components: {DetailCourse},
  computed: {},

  props: {
    comboId: {type: Number, required: true, default: null}
  },

  created() {
  },

  async mounted() {
  },
  data() {
    return {
      combo: Object,
      dialogDetailCourse: true,
      currentCourse: Object,
      apiService: new ApiService(),
      rules: {
        required: (value) => !!value || "Campo requerido.",
      }
    };
  },

  methods: {
    close() {
      this.$emit('close')
    },

    formatDate(date) {
      return Utils.momentDay(date);
    },
    formatCurrency(value) {
      return UtilsFormatCurrency.formatCurrency(value);
    },
    showDialogDetailCourse(course) {
      this.currentCourse = course
      this.dialogDetailCourse = true
      setTimeout(() => {
        this.$refs.detailCourse.getCourse()
      }, 100)
    },

    async goToRoute() {
      await this.$router.push({
        path: `/combos-cadastrar`,
        query: {comboId: this.comboId}
      });
    },
    async getCombo() {
      try {
        const {content} = await this.apiService.get(`combo/${this.comboId}`,)
        this.combo = content

      } catch (e) {

      }
    },
  },

  watch: {},
};
</script>

<style lang='scss' scoped>
.title-toolbar {
  font-size: 19px;
  margin-left: -15px;
  margin-bottom: -2px;
  font-weight: 500;
}

</style>
